import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SuperAdminAuditPage } from '@/pages/super-admin/audit/SuperAdminAuditPage';

const auditSearchSchema = z.object({
	companyId: z.string().optional(),
	actorId: z.string().optional(),
	category: z.string().optional(),
	targetType: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/audit')({
	component: SuperAdminAuditPage,
	validateSearch: auditSearchSchema,
});
